export default __webpack_public_path__ + "static/social-52ea05bf2a43163c8ce8efd13bf99296.jpg";